import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import MachineDetail from "../../components/maintenance/MachineDetail";
import {
  fetchMachine,
  fetchMachineSuccess,
  fetchMachineFailure,
  fetchMachineMaintenanceHistory,
  fetchMachineMaintenanceHistorySuccess,
  fetchMachineMaintenanceHistoryFailure,
  startMachineMaintenance,
  startMachineMaintenanceSuccess,
  startMachineMaintenanceFailure,
  deleteMachine,
  deleteMachineSuccess,
  deleteMachineFailure,
  clearCurrentMachine,
} from "../../store/maintenance/actions";

const MachineDetailContainer = ({
  machines,
  fetchMachine,
  fetchMachineMaintenanceHistory,
  startMachineMaintenance,
  deleteMachine,
  clearCurrentMachine,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchMachine(id);
      fetchMachineMaintenanceHistory(id);
    }
    return () => {
      clearCurrentMachine();
    };
  }, [id, fetchMachine, fetchMachineMaintenanceHistory, clearCurrentMachine]);

  const handleStartMaintenance = useCallback(
    (machineId) => {
      if (window.confirm("Mark this machine as under maintenance?")) {
        startMachineMaintenance(machineId, () => {
          fetchMachine(machineId);
        });
      }
    },
    [startMachineMaintenance, fetchMachine]
  );

  const handleDelete = useCallback(
    (machineId) => {
      if (window.confirm("Are you sure you want to delete this machine? This action cannot be undone.")) {
        deleteMachine(machineId, () => {
          navigate("/maintenance/machines");
        });
      }
    },
    [deleteMachine, navigate]
  );

  return (
    <MachineDetail
      machine={machines.current}
      maintenanceHistory={machines.maintenanceHistory}
      loading={machines.loading}
      error={machines.error}
      onStartMaintenance={handleStartMaintenance}
      onDelete={handleDelete}
    />
  );
};

const mapStateToProps = (state) => ({
  machines: state.maintenance.machines,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMachine: (id) => {
    dispatch(fetchMachine(id)).payload.then(
      (response) => {
        dispatch(fetchMachineSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMachineFailure(error.response?.data || error));
      }
    );
  },
  fetchMachineMaintenanceHistory: (id) => {
    dispatch(fetchMachineMaintenanceHistory(id)).payload.then(
      (response) => {
        dispatch(fetchMachineMaintenanceHistorySuccess(response.data));
      },
      (error) => {
        dispatch(fetchMachineMaintenanceHistoryFailure(error.response?.data || error));
      }
    );
  },
  startMachineMaintenance: (id, callback) => {
    dispatch(startMachineMaintenance(id)).payload.then(
      (response) => {
        dispatch(startMachineMaintenanceSuccess(response.data));
        if (callback) callback();
      },
      (error) => {
        dispatch(startMachineMaintenanceFailure(error.response?.data || error));
      }
    );
  },
  deleteMachine: (id, callback) => {
    dispatch(deleteMachine(id)).payload.then(
      () => {
        dispatch(deleteMachineSuccess(id));
        if (callback) callback();
      },
      (error) => {
        dispatch(deleteMachineFailure(error.response?.data || error));
      }
    );
  },
  clearCurrentMachine: () => {
    dispatch(clearCurrentMachine());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineDetailContainer);
